export default [
  {
    name: "Skalierung",
    properties: [
      {
        name: "Scale",
        value: "transform: scale()",
        type: "number",
      },
      {
        name: "Scale 3D",
        value: "transform: scale3d()",
        type: "number",
      },
      {
        name: "Scale X",
        value: "transform: scaleX()",
        type: "number",
      },
      {
        name: "Scale Y",
        value: "transform: scaleY()",
        type: "number",
      },
      {
        name: "Scale Z",
        value: "transform: scaleZ()",
        type: "number",
      },
    ],
  },
  {
    name: "Verschiebung",
    properties: [
      {
        name: "Translate",
        value: "transform: translate()",
        type: "length",
      },
      {
        name: "Translate 3D",
        value: "transform: translate3d()",
        type: "length",
      },
      {
        name: "Translate X",
        value: "transform: translateX()",
        type: "length",
      },
      {
        name: "Translate Y",
        value: "transform: translateY()",
        type: "length",
      },
      {
        name: "Translate Z",
        value: "transform: translateZ()",
        type: "length",
      },
    ],
  },
  {
    name: "Verzerrung",
    properties: [
      {
        name: "Skew",
        value: "transform: skew()",
        type: "angle",
      },
      {
        name: "Skew X",
        value: "transform: skewX()",
        type: "angle",
        shorthand: "transform: skew()",
      },
      {
        name: "Skew Y",
        value: "transform: skewY()",
        type: "angle",
        shorthand: "transform: skew()",
      },
    ],
  },
  {
    name: "Drehung",
    properties: [
      {
        name: "Rotate",
        value: "transform: rotate()",
        type: "angle",
      },
      {
        name: "Rotate 3D",
        value: "transform: rotate3d()",
        type: "angle",
      },
      {
        name: "Rotate X",
        value: "transform: rotateX()",
        type: "angle",
      },
      {
        name: "Rotate Y",
        value: "transform: rotateY()",
        type: "angle",
      },
      {
        name: "Rotate Z",
        value: "transform: rotateZ()",
        type: "angle",
      },
    ],
  },
  {
    name: "Matrix Transformation",
    properties: [
      {
        name: "Matrix",
        value: "transform: matrix()",
        type: "number",
      },
      {
        name: "Matrix 3D",
        value: "transform: matrix3d()",
        type: "number",
      },
    ],
  },
  {
    name: "Einstellungen für Transformationen",
    properties: [
      {
        name: "Perspective",
        value: "transform: perspective()",
        type: "length",
      },
      {
        name: "Transform Box",
        value: "transform-box",
        type: "text",
        autocomplete: ["content-box", "border-box", "fill-box", "view-box", "stroke-box"],
      },
      {
        name: "Transform Origin",
        value: "transform-origin",
        type: ["text", "length", "percentage"],
        autocomplete: ["left", "center", "right", "top", "bottom"],
      },
      {
        name: "Transform Style",
        value: "transform-style",
        type: "text",
        autocomplete: ["flat", "preserve-3d"],
      },
      {
        name: "Backface Visibility",
        value: "backface-visibility",
        type: "text",
        autocomplete: ["visible", "hidden"],
      },
    ],
  },
];
